export const isInternalLink = link => /^\/(?!\/)/.test(link);
